<template>
    <div>
        <HealthCheck :menuNameLower="menuNameLower" :menuNameUpper="menuNameUpper"/>
    </div>
</template>

<script>
    // @ is an alias to /src

    import HealthCheck from '@/app/components/HealthCheck.vue'

    export default {
        name: 'healthCheckInput',
        components: {
            HealthCheck
        },
        computed: {
            menuNameUpper: function () {
                const button = this.$store.getters['buttons/topButton'](this.$route.params.menuId)
                return 'upperButtonName' in button ? button.upperButtonName : ''
            },
            menuNameLower: function () {
                const button = this.$store.getters['buttons/topButton'](this.$route.params.menuId)
                return 'lowerButtonName' in button ? button.lowerButtonName : ''
            }
        },
    }
</script>
